<template>
  <v-layout row wrap>
    <v-flex xs12>
      <v-slide-y-transition group>
        <!-- Nuevo Registro -->
        <v-card
          class="pa-3 mb-2 expandableContainer elevation-0"
          v-for="item in newUds"
          :key="item.id"
        >
          <v-layout row wrap>
            <v-flex xs12 sm4>
              <v-layout row wrap justify-center fill-height align-center>
                <v-flex xs12>
                  <h2 class="font-weight-regular">Nuevo Dispositivo</h2>
                  <p>Dispositivo Klipy</p>
                  <p>
                    1.- Ve a la aplicación Skolable Klipy
                    <br />2.- Apunta el dispositivo al código Qr de la pantalla
                  </p>
                </v-flex>
              </v-layout>
            </v-flex>
            <v-flex xs12 sm4>
              <v-list subheader> </v-list>
            </v-flex>
            <v-flex xs12 sm4>
              <v-layout row wrap justify-center>
                <v-flex xs6>
                  <v-img :src="'data:image/png;base64,' + item.qr"></v-img>
                  <v-btn dark color="gradiente" round @click="cancelInterval">
                    {{ $t('generic.cancel') }}
                  </v-btn>
                </v-flex>
              </v-layout>
            </v-flex>
          </v-layout>
        </v-card>

        <!-- Los que ya estan registrados -->
        <v-card
          class="pa-3 mb-2 expandableContainer elevation-0"
          v-for="item in uds"
          :key="item.id"
        >
          <v-layout row wrap>
            <v-flex xs12 sm4>
              <v-layout row wrap justify-center fill-height align-center>
                <v-flex xs12 sm12>
                  <h2 class="font-weight-regular">
                    {{ $t('devices.synchronized_device') }}
                  </h2>

                  <p style="margin-top: 16px; margin-left: 30px">
                    {{ item.deviceName }}
                    <v-tooltip bottom>
                      <v-btn
                        fab
                        flat
                        small
                        slot="activator"
                        @click="editDevice(item)"
                      >
                        <v-icon>edit</v-icon>
                      </v-btn>
                      <span>Editar nombre</span>
                    </v-tooltip>
                  </p>
                  <v-btn
                    v-if="permits['UNLINK_DEVICES']"
                    dark
                    color="gradiente"
                    round
                    @click="unlink(item)"
                  >
                    {{ $t('devices.unpair') }}
                  </v-btn>
                </v-flex>
              </v-layout>
            </v-flex>
            <v-flex xs12 sm4>
              <p>Dispositivo Klipy</p>
              <v-list subheader> </v-list>
            </v-flex>
            <v-flex xs12 sm4>
              <v-layout row wrap justify-center>
                <v-flex xs6>
                  <v-img
                    :src="require('@/assets/panel/devices/sk-qr.png')"
                  ></v-img>
                </v-flex>
              </v-layout>
            </v-flex>
          </v-layout>
        </v-card>
        <!-- Cargando -->
        <v-card
          class="pa-3 mb-2 elevation-0"
          :key="'loading'"
          v-if="working.loadingList"
        >
          <v-layout row wrap justify-center fill-height align-center>
            <v-flex xs12>
              <h3>
                <b>Cargando</b>
              </h3>
              <v-progress-linear :indeterminate="true"></v-progress-linear>
            </v-flex>
          </v-layout>
        </v-card>

        <!-- Ningun registro aun -->
        <v-card
          class="pa-3 mb-2 elevation-0"
          :key="0"
          v-else-if="uds.length == 0 && newUds.length == 0"
        >
          <v-layout row wrap justify-center fill-height align-center>
            <v-flex xs12 sm3>
              <v-img
                :src="require('@/assets/panel/devices/new_devices.png')"
              ></v-img>
              <h3 style="color: #545871; font-weight: bold">
                Aún no tienes klipys activos
              </h3>
              <h4>
                Presiona el botón + para agregar un dispositivo mediante código
                QR
              </h4>
            </v-flex>
          </v-layout>
        </v-card>
      </v-slide-y-transition>
    </v-flex>
    <!-- Toast -->
    <klipyEdit
      v-model="modals.editKlipyReady"
      @cancelled="onCancel"
      :klipy="selected.device"
    ></klipyEdit>
    <loading v-model="working.w" text="Trabajando..."></loading>
    <success v-model="toast.success" :text="toast.title"></success>
    <error v-model="toast.failed" text="Ups ocurrió un error"></error>
  </v-layout>
</template>

<script>
import { mapGetters } from 'vuex'
import error from '../../Dialogs/Error.vue'
import loading from '../../Dialogs/Loading.vue'
import success from '../../Dialogs/Success.vue'
import klipyEdit from '../../Sections/Devices/KlipyEditModal'
export default {
  components: {
    loading,
    success,
    error,
    klipyEdit,
  },
  props: ['add', 'permits'],
  mounted() {
    if (this.getBranch.id != null) {
      this.getKlipy()
    }
  },
  watch: {
    getBranch() {
      this.getKlipy()
    },
    add() {
      if (this.add) {
        //Cuando se llama el add desde Device
        this.beginSync()
      }
    },
  },
  data: () => ({
    uds: [],
    newUds: [],
    working: {
      loadingList: true,
      w: false,
    },
    toast: {
      success: false,
      failed: false,
      title: '',
    },
    loop: {
      loop: null,
      looptime: 0,
    },
    modals: {
      editKlipyReady: false,
    },
    selected: {
      device: [],
    },
  }),
  methods: {
    //Ya registrasdos
    getKlipy() {
      this.working.loadingList = true
      this.$store
        .dispatch('ud/getKlipy')
        .then((response) => {
          this.working.loadingList = false
          //Llena el areglo de los que estan dados de alta
          this.uds = response.data
        })
        .catch((error) => {
          this.working.loadingList = false
          console.log(error)
        })
    },
    //Solicita crear el codigo qr
    beginSync() {
      this.working.w = true
      this.$store
        .dispatch('ud/genQrCodeK')
        .then((response) => {
          this.working.w = false
          this.toast.title = 'Sincronización iniciada'
          this.toast.success = true
          this.$emit('startInterval')
          //Inicia el tiempo de espera
          this.startInterval(response)
          //Agrega a el arreglo la respuesta del qr
          this.newUds.push(response.data)
          this.$emit('added')
        })
        .catch((error) => {
          this.working.w = false
          this.toast.failed = true
          console.log(error)
        })
    },
    //Resive la respuesta del qr
    startInterval(event) {
      var v = this
      //loop de tiempo para sincronizar dispositivo
      this.loop.loop = setInterval(() => {
        //Tiempo de espera para pasar a estado de cancelado
        if (v.loop.looptime < 1200) {
          v.$store.dispatch('ud/getQrK', event.data.id).then((response) => {
            if (response.data.sync) {
              //Para el tiempo y guarda
              v.stopInterval()
              v.newUds = []
              //Se acredito la cesión
              v.toast.title = 'Sincronización exitosa'
              v.toast.success = true
              //Vuelve a cargar todos los registros
              v.getKlipy()
            }
          })
          v.loop.looptime++
        } else {
          //Cancela la configuracion y borra
          v.cancelInterval()
        }
      }, 1000)
    },
    //Cancela por tiempo
    cancelInterval() {
      this.$emit('stopInterval')
      this.deleteNewQR()
      this.stopInterval()
    },
    //Cancela por resultado correcto
    stopInterval() {
      //Se recetea el tiempo
      clearInterval(this.loop.loop)
      this.loop.looptime = 0
      this.$emit('stopInterval')
    },
    //Borra el qr que se genero
    deleteNewQR() {
      this.working.w = true
      this.$store
        .dispatch('ud/deleteNewQrK', this.newUds[0].id)
        .then(() => {
          this.working.w = false
          //Limpia el arreglo de nuevo dispositivo
          this.newUds = []
          this.toast.title = 'Sincronización cancelada'
          this.toast.success = true
        })
        .catch((error) => {
          this.working.w = false
          this.toast.failed = true
          console.log(error)
        })
    },
    //Desactiva la cesión que se esta usandp
    unlink(qr) {
      this.working.w = true
      this.$store
        .dispatch('ud/unLinkQRK', qr.id)
        .then(() => {
          this.working.w = false
          this.toast.title = 'Eliminación Exitosa'
          this.toast.success = true
          //Quita del arreglo al dispositivo eliminado
          this.uds.splice(this.uds.indexOf(qr), 1)
        })
        .catch((error) => {
          this.working.w = false
          this.toast.failed = true
          console.log(error)
        })
    },
    editDevice(item) {
      this.selected.device = item
      this.modals.editKlipyReady = true
    },
    onCancel() {
      this.modals.editKlipyReady = false
      this.$forceUpdate()
    },
    handleKeyDown(e) {
      //method to handle the keypress
      if (e.code === 'Escape') {
        this.onCancel()
      }
    },
    onCancel() {
      this.modals.editKlipyReady = false
      this.$forceUpdate()
    },
  },
  created() {
    window.addEventListener('keydown', this.handleKeyDown) //will attach the event listener to the whole window when the component is created
  },
  destroyed() {
    window.removeEventListener('keydown', this.handleKeyDown) //will detach the event listener once the component is destroyed
  },
  computed: {
    //Mappers
    ...mapGetters(['getBranch']),
  },
}
</script>

<style></style>
